import varint from 'varint';
import { fromString as uint8ArrayFromString } from 'uint8arrays/from-string';
import { toString as uint8ArrayToString } from 'uint8arrays/to-string';

import { Hex, hexToBytes, toHex } from 'viem';
import { addPrefix, removePrefix } from './utils';
import { codeToName } from './maps';

export class ContentHash {
  static encode(type: string, data: string) {
    const encodedValue = uint8ArrayFromString(data, 'utf-8');
    return toHex(addPrefix(type, encodedValue));
  }

  static decode(hash: Hex) {
    const decodeBytes = hexToBytes(hash);

    const value = removePrefix(decodeBytes);
    return uint8ArrayToString(value, 'utf-8');
  }

  static getType(data: Uint8Array) {
    const code = varint.decode(data);
    const name = codeToName[code];
    if (name === undefined) {
      throw new Error(`Code "${code}" not found`);
    }
    return name;
  }

  static isOfType(hash: Hex, type: string) {
    const data = hexToBytes(hash);
    const name = ContentHash.getType(data);
    return name === type;
  }
}
